export default [
  {
    category: "Care",
    sub_categories: [
      "Adoption & Foster Care",
      "Animal Welfare",
      "Daytime Care",
      "End-of-Life Care",
      "Navigating the System",
      "Residential Care",
      "Support Network",
    ],
  },
  {
    category: "Education",
    sub_categories: [
      "Help Find School",
      "Help Pay for School",
      "More Education",
      "Preschool",
      "Screening & Exams",
      "Skills & Training",
    ],
  },
  {
    category: "Emergency",
    sub_categories: [
      "Disaster Response",
      "Emergency Payments",
      "Emergency Food",
      "Emergency Shelter",
      "Help Find Missing Persons",
      "Immediate Safety",
      "Psychiatric Emergency Services",
    ],
  },
  {
    category: "Food",
    sub_categories: [
      "Community Gardens",
      "Emergency Food",
      "Food Delivery",
      "Food Pantry",
      "Free Meals",
      "Help Pay for Food",
      "Nutrition",
    ],
  },
  {
    category: "Goods",
    sub_categories: [
      "Baby Supplies",
      "Clothing",
      "Home Goods",
      "Medical Supplies",
      "Toys and Gifts",
    ],
  },
  {
    category: "Health",
    sub_categories: [
      "Addiction & Recovery",
      "Dental Care",
      "End-of-Life Care",
      "Health Education",
      "Help Pay for Healthcare",
      "Medical Care",
    ],
  },
  {
    category: "Housing",
    sub_categories: [
      "Emergency Shelter",
      "Help Find Housing",
      "Help Pay for Housing",
      "Housing Advice",
      "Residential Housing",
    ],
  },
  {
    category: "Legal",
    sub_categories: [
      "Advocacy & Legal Aid",
      "Mediation",
      "Notary",
      "Representation",
      "Translation & Interpretation",
    ],
  },
  {
    category: "Money",
    sub_categories: [
      "Financial Assistance",
      "Government Benefits",
      "Financial Education",
      "Insurance",
      "Tax Preparation",
    ],
  },
  {
    category: "Transit",
    sub_categories: ["Help Pay for Transit", "Transportation"],
  },
  {
    category: "Work",
    sub_categories: [
      "Help Find Work",
      "Help Pay for Work Expenses",
      "Skills & Training",
      "Supported Employment",
      "Workplace Rights",
    ],
  },
];
